// extracted by mini-css-extract-plugin
export default {"scrollbar":"_3p090","scrollbarSSR":"_2HsLd","layoutContainer":"_38aLf","layoutContainerSSR":"-zx-v","leftMenu":"_3NCZF","leftMenuNew":"_1dycY"};